import { render, staticRenderFns } from "./ShopData.vue?vue&type=template&id=3690d842&scoped=true&"
import script from "./ShopData.vue?vue&type=script&lang=js&"
export * from "./ShopData.vue?vue&type=script&lang=js&"
import style0 from "./ShopData.vue?vue&type=style&index=0&id=3690d842&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690d842",
  null
  
)

export default component.exports